export enum ProfilePreferencesTypeE {
  allowEmail = 'ALLOW_MARKETING_EMAIL_CONTACT',
  allowPhone = 'ALLOW_MARKETING_PHONE_CONTACT',
  allowSMS = 'ALLOW_MARKETING_SMS_CONTACT',
  allowPlatform = 'ALLOW_MARKETING_PLATFORM_CONTACT',
}
